import React from 'react';
import {Intro, About, Experience, Projects, Footer, ScrollToTopButton} from './Imports';

function Main() {

    return (
        <div className="main" >

            <Intro/>

            <About/>

            <Experience/>

            <Projects/>

            <Footer/>

            <ScrollToTopButton/>

        </div>
    )
}

export default Main
